// Small preferences that belong to this player on this computer, like which background they play in.
// They are not part of the game and are never sent to the other player. They are kept in the browser so
// they are still there next time; where the browser won't keep them, they last until the page is closed.
import { CONFIG } from '../config.ts';

const KEY = 'arellix.background';
let background = '';
try {
  background = window.localStorage.getItem(KEY) ?? '';
} catch {
  // no storage here (a private window, a preview page): the choice just isn't remembered
}

/** The background this player has chosen (an id from `backgrounds.list` in the settings), or the default one. */
export function chosenBackground(): string {
  const B = CONFIG.backgrounds;
  return B.list.some((b) => b.id === background) ? background : B.default;
}

export function chooseBackground(id: string) {
  background = id;
  try {
    window.localStorage.setItem(KEY, id);
  } catch {
    // see above
  }
}
